import React from "react";

const ImageEnhancementIcon = ({ color }) => {
  return (
    <svg width="18" height="18" viewBox="0 0 17 18" fill="none" className="active-nav-icon" xmlns="http://www.w3.org/2000/svg">
      {/* Image frame */}
      <rect x="0.6" y="0.6" width="10.8" height="8.8" rx="1.2" stroke={color} strokeWidth="1.2" fill="none" />
      {/* Sun */}
      <circle cx="3.8" cy="3.5" r="1.3" fill={color} />
      {/* Mountains */}
      <path d="M2.8 8.4 L6 4.5 L9.2 8.4 Z" fill={color} />
      <path d="M6.5 8.4 L9.2 5.8 L11.2 8.4 Z" fill={color} opacity="0.6" />
      {/* Enhancement spark */}
      <path d="M13.5 0.8 L14.2 2.8 L16.2 3.5 L14.2 4.2 L13.5 6.2 L12.8 4.2 L10.8 3.5 L12.8 2.8 Z" fill={color} />
      {/* Slider panel */}
      <rect x="0.6" y="10.6" width="15.8" height="6.8" rx="1.2" stroke={color} strokeWidth="1.2" fill="none" />
      {/* Slider track */}
      <line x1="2.8" y1="14" x2="14.2" y2="14" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
      {/* Slider knob */}
      <circle cx="8.5" cy="14" r="1.6" fill={color} />
    </svg>
  );
};

export default ImageEnhancementIcon;
